<template>
  <base-modal size="lg" hide-footer hide-header>
    <div class="col-12" style="background-color: #FFFFFF; margin: auto" @click.stop>
      <div style="position: relative; height: 55vh; padding: 1em; text-align: left;">
        <map-container
          ref="mapContainer"
          :find-user="false"
          @on-map-changed="mapChanged"
        />
      </div>
      <div v-if="addShape" class="col-12 px-3 pb-3">
          <shape-import-form
            @file-picked="shapeFileSelected"
            @cancel="$emit('close')"
          />
          <div>
            <span class="span-title pl-2">{{ $t('import_file_wizard.use_coordinate_system') }}: ETRS-TM35FIN (epsg: 3067)</span>
          </div>
          <div class="button-container pr-1">
              <button
                  class="btn btn-secondary btn-sm form-button"
                  @click.stop="$emit('close')"
              >
                  {{ $t('common.cancel') }}
              </button>
              <button
                  class="btn btn-sm btn-success form-button"
                  :disabled="!shpFile || !shxFile || !dbfFile || loading"
                  @click.stop="showGeometryOnMap"
              >
                  {{ $t('orders.show_geometry_on_map') }}
              </button>
          </div>
        </div>
      <div v-else class="col-12 d-flex justify-content-end">
          <button
              class="btn btn-sm btn-secondary form-button"
              @click.stop="$emit('close')"
          >
              {{ $t('common.cancel') }}
          </button>
          <button
              class="btn btn-sm btn-success form-button"
              @click.stop="addItems"
          >
              {{ $t('storm_sewers.add_to_system') }}
          </button>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </base-modal>
</template>


<script>
import {restApi} from '../mixins/RestApiMixin'
import {mapHelper} from "@/components/mixins/MapMixin";
import ShapeImportForm from "@/components/shapeimport/ShapeImportForm";
import MapContainer from "@/components/map/MapContainer";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'StormDrainImporter',
    components: {BaseModal, MapContainer, ShapeImportForm},
    mixins: [restApi, mapHelper],
    props: {
        user: {
            type: Object,
            default: null
        },
    },
    data: function () {
        return {
            addShape: true,
            loading: false,
            shpFile: null,
            shxFile: null,
            dbfFile: null,
            geoJson: null
        }
    },
    methods: {
        mapChanged(map) {
            this.map = map
            if(this.getMapSettingsIn(['center'])){
                let center = this.getMapSettingsIn(['center'])
                if (this.map && center && center.lat ) {
                    this.map.zoomToPosition(center.lat, center.lng, this.map.getMapZoomLevel())
                }
            }
        },
        shapeFileSelected: function (shpFile, shxFile, dbfFile) {
            this.shpFile = shpFile
            this.shxFile = shxFile
            this.dbfFile = dbfFile
        },
        showGeometryOnMap: function () {
            let formData = new FormData()
            let files = [this.shpFile, this.shxFile, this.dbfFile]
            files.forEach(file => {
                if (file !== undefined && file !== null) {
                    formData.append('files[]', file)
                }
            })
            this.loading = true
            this.restPostWithFile(this.convertShapeToGeoJsonUrl, {}, formData, this.handleGeoJson, this.onFailedRequest)
        },
        handleGeoJson: function(geoJson){
            this.geoJson = geoJson
            this.map.addGeoJsonObjects(geoJson, true, '#1a6fb9')
            this.addShape = false
            this.loading = false
        },
        onFailedRequest() {
            this.loading = false
            this.showAlert(this.$t('import_file_wizard.import_failed'))
        },
        addItems() {
            if (this.geoJson) {
                this.loading = true
                this.restAdd(this.stormDrainBulkUrl, {geoJson: this.geoJson}, this.handleAdd, this.addFailed)
            }
        },
        handleAdd() {
            this.loading = false
            this.$emit('close')
        },
        addFailed() {
            this.loading = false
            this.showAlert(this.$t('storm_sewer.sewer_add_failed'))
        },
    }
}
</script>
